import { render, staticRenderFns } from "./AddToSuggestion.vue?vue&type=template&id=7927b805"
import script from "./AddToSuggestion.vue?vue&type=script&lang=js"
export * from "./AddToSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_webpack@5.99.9__lodash@4.17.21_vue-template-compiler@2.6.14_webpack@5.99.9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports